import { AccessToken } from '@okta/okta-auth-js';
import { DeviceTelemetryApi, NearbyWifiNetwork } from '../TelematicsDevice/DeviceTelemetryApi';

export interface NearbyWifiScanResult {
  nearbyWifiNetworks: NearbyWifiNetwork[];
  nearbyWifiNetworksUpdatedTime?: string;
}

const getLastScan = async (
  accessToken: AccessToken | undefined,
  deviceId: string
): Promise<NearbyWifiScanResult> => {
  const telemetry = await DeviceTelemetryApi.getTelemetry(accessToken, deviceId);
  const wifi = telemetry.connectivity.wifi;

  return {
    nearbyWifiNetworks: Array.isArray(wifi.nearbyWifiNetworks)
      ? wifi.nearbyWifiNetworks.filter(network => Boolean(network.ssid))
      : [],
    nearbyWifiNetworksUpdatedTime: wifi.nearbyWifiNetworksUpdatedTime,
  };
};

export const WifiScanApi = { getLastScan };
